import { Component, Input, OnInit } from '@angular/core';
import { ServiceManagementCounts } from 'src/app/core/interfaces/status-counts/service-management-counts';

@Component({
  selector: 'app-service-management-counts',
  templateUrl: './service-management-counts.component.html',
  styleUrls: ['./service-management-counts.component.scss'],
})
export class ServiceManagementCountsComponent implements OnInit {
  @Input() serviceManagementCounts: ServiceManagementCounts;

  constructor() {}

  ngOnInit(): void {}
}
